import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTeams = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/teams`);
};

export const useTeams = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["teams", churchId],
    queryFn: () => getTeams({ churchId })
  });
};
